import React from 'react';

import IconType from '../IconType';
import SVGIcon from '../SVGIcon';

const CSS = require('./BoltIcon.module.scss');

type BoltIconProps = {
  variant?:
    | 'yellow'
    | 'pink'
    | 'warning'
    | 'success'
    | 'error'
    | 'bright-green';
} & IconType;

function BoltIcon({ variant, ...props }: BoltIconProps) {
  return (
    <SVGIcon {...props} size={props.size ?? 24} viewBox="0 0 24 24">
      <path
        d="M18.1695128,10.0477352 L13.2401291,9.94409186 L14.6240781,2.92358311 C14.6930263,2.57634028 14.4895044,2.20413227 14.1347948,2.06493253 C13.7800851,1.92573278 13.3647343,2.01348914 13.137122,2.29794079 L5.16155525,12.1841486 C4.97547807,12.4141308 4.94806492,12.5631653 5.0901149,12.8173561 C5.23216489,13.0715469 5.51875697,13.0738165 5.8311008,13.0738165 L10.7770986,13.2160423 L9.38151976,21.0634278 C9.31921714,21.4144533 9.53270748,21.7957395 9.8940627,21.9266175 C9.9937469,21.963687 10.0984153,22 10.2014223,22 C10.4705697,22 10.7305793,21.8903046 10.8892433,21.6777223 L18.8565031,11.0516376 C19.029289,10.8201424 19.0475645,10.5818385 18.9030224,10.3344564 C18.759311,10.0870742 18.4768724,10.0477352 18.1695128,10.0477352 Z"
        data-variant={variant}
        className={CSS.Bolt}
      />
    </SVGIcon>
  );
}

export default BoltIcon;
